import { Box, Checkbox, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import HeaderOuBannerDependendoDaInterpretacaoH1 from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import { useState } from 'react';
import { currencyOf } from 'utils/util';
import { LinhaCupomTroca } from './cupom-troca.model';

export type CupomTrocaSelecaoDialogProps = {
    itens: Array<LinhaCupomTroca>;
    onCancelar: () => void;
    onConfirmar: (selecionados: Array<LinhaCupomTroca>) => void;
    loading?: boolean;
};

const CupomTrocaSelecaoDialog = (props: CupomTrocaSelecaoDialogProps) => {
    const [itens, setItens] = useState<Array<LinhaCupomTroca>>(props.itens);

    const totalSelecionados = itens.filter(item => item.selecionado).length;
    const estadoSelecaoTodos: boolean | 'parcial' =
        totalSelecionados === 0 ? false : totalSelecionados === itens.length ? true : 'parcial';

    const onToggleItem = (id: string) => {
        setItens(prevState => prevState.map(item => (item.id === id ? { ...item, selecionado: !item.selecionado } : item)));
    };

    const onToggleTodos = (checked: boolean) => {
        setItens(prevState => prevState.map(item => ({ ...item, selecionado: checked })));
    };

    return (
        <CustomDialog
            id='cupom-troca'
            open
            fullWidth
            maxWidth={'lg'}
            onClose={props.onCancelar}
        >
            <DialogTitle textAlign={'center'}>
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id='cupom-troca-selecao-header'
                    iconClassName='fa-solid fa-receipt'
                    label='Imprimir cupom de troca?'
                />
            </DialogTitle>

            <DialogContent>
                <Typography sx={{ marginBottom: '10px' }}>
                    Selecione os itens que o cliente poderá trocar. Um cupom será impresso para cada unidade selecionada.
                </Typography>

                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell padding='checkbox'>
                                <Checkbox
                                    id='cupom-troca-selecionar-todos-checkbox'
                                    checked={estadoSelecaoTodos === true}
                                    indeterminate={estadoSelecaoTodos === 'parcial'}
                                    onChange={(_, checked) => onToggleTodos(checked)}
                                />
                            </TableCell>
                            <TableCell>SKU</TableCell>
                            <TableCell>Descrição</TableCell>
                            <TableCell align='right'>Preço praticado</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itens.map(item => (
                            <TableRow key={item.id}>
                                <TableCell padding='checkbox'>
                                    <Checkbox
                                        id={`cupom-troca-item-${item.id}-checkbox`}
                                        checked={item.selecionado}
                                        onChange={() => onToggleItem(item.id)}
                                    />
                                </TableCell>
                                <TableCell>{item.codigoSku}</TableCell>
                                <TableCell>{item.descricao}</TableCell>
                                <TableCell align='right'>{currencyOf(item.precoPraticado)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <Box display={'flex'} justifyContent={'space-between'} marginTop={'20px'}>
                    <CustomButton
                        id='cupom-troca-cancelar-btn'
                        onClick={props.onCancelar}
                        variant='contained'
                        color='error'
                    >
                        Cancelar
                    </CustomButton>

                    <CustomButton
                        id='cupom-troca-confirmar-btn'
                        onClick={() => props.onConfirmar(itens.filter(item => item.selecionado))}
                        disabled={totalSelecionados === 0 || !!props.loading}
                        variant='contained'
                        color='success'
                    >
                        Confirmar
                    </CustomButton>
                </Box>
            </DialogContent>
        </CustomDialog>
    );
};

export default CupomTrocaSelecaoDialog;
